import { Button, Card, CardActions, CardContent, CardHeader, Grid, IconButton, Stack, Tooltip, Typography } from '@mui/material';
import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom';
import Swal from 'sweetalert2';
import { AuthStore } from '../../../../store/UserStore';
import { base_url } from '../../../../utils/GlobalVariables';
import { CustomDescrypt } from '../../../../utils/MyEncryption';
import InfoIcon from '@mui/icons-material/Info';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import Form from './Form';

const DataBud = () => {
    const logOut = AuthStore((state) => state.logOut)
    const encryptUser = localStorage.getItem('AuthPersist');
    const encryptUserJson = JSON.parse(encryptUser);
    const decryptedUser = encryptUserJson.state.user === null ? "" : JSON.parse(CustomDescrypt(encryptUserJson.state.user));
    const [deleting, setDeleting] = useState([]);
    const [edit, setEdit] = useState(null);
    const [tableData, setTableData] = useState([]);

    useEffect(() => {
        requestData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [deleting, edit])

    const requestData = () => {
        // setTableLoading(true)
        axios.get(
            base_url + '/admin/bud',
            {
                headers: {
                    'Authorization': `Bearer ${decryptedUser.token}`
                }
            })
            .then((response) => {
                console.log(response);
                setTableData(response.data)
                // setTableLoading(false)
            })
            .catch((error) => {
                if (error.response.status === 401 && error.response.data.messages === "Access Token Expired") {
                    logOut();
                }
                else {
                    Swal.fire({
                        icon: 'error',
                        title: 'Oops...',
                        text: error.response.status + ' ' + error.response.statusText
                    })
                }
                // setTableLoading(false)
            })
    }

    const onDelete = (params) => {
        setDeleting(true);
        const frmData = {
            _method: 'DELETE',
            username: params.nip
        }

        Swal.fire({
            title: 'Hapus Data?',
            text: "Operasi tidak dapat Dikembalikan!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            showLoaderOnConfirm: true,
            confirmButtonText: 'Ya, Hapus!',
            cancelButtonText: 'Batal',
            preConfirm: () => {
                return axios.post(
                    base_url + '/admin/bud/delete',
                    frmData,
                    {
                        headers: {
                            'Authorization': `Bearer ${decryptedUser.token}`,
                            'content-type': 'multipart/form-data'
                        }
                    })
                    .then((response) => {
                        requestData();
                        return response.data
                    })
                    .catch((error) => {
                        console.log(error);
                        if (error.response.status === 401 && error.response.data.messages === "Access Token Expired") {
                            logOut();
                        }
                        else {
                            console.log(error.response);
                            Swal.showValidationMessage(
                                `Request failed: ${error.response.statusText}`
                            )
                        }
                    })
            },
            allowOutsideClick: () => !Swal.isLoading()
        }).then((result) => {
            console.log(result);
            if (result.isConfirmed) {
                Swal.fire(
                    'Selesai!',
                    result.value,
                    'success'
                )
            }
        })

    }

    const onEdit = (params) => {
        setEdit(null);
        let dt = {
            nip: params.nip,
            nama: params.nama,
            pangkat: params.pangkat,
            golongan: params.golongan,
            jabatan: params.jabatan
        };
        setEdit(dt)
    }

    return (
        <>
            {edit === null ?
                <Card variant='outlined'>
                    <CardHeader
                        title="BUD dan Kuasa BUD"
                        action={
                            <Button
                                variant="contained"
                                endIcon={<AddCircleOutlineIcon color='white' />}
                                to="/admin/bud/add"
                                component={Link}
                            >
                                Tambah
                            </Button>
                        }
                    />
                    <CardContent>
                        <Grid container spacing={2}>
                            {tableData.length > 0 ?
                                tableData.map((item) => {
                                    return (
                                        <Grid item xs={12} md={6} xl={4} key={item.nip}>
                                            <Card>
                                                <CardContent>
                                                    <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>
                                                        {item.jabatan}
                                                    </Typography>
                                                    <Typography variant="h5" component="div">
                                                        {item.nama}
                                                    </Typography>
                                                    <Typography sx={{ mb: 1.5 }} color="text.secondary">
                                                        {item.nip}
                                                    </Typography>
                                                    <Typography variant="body2">
                                                        {item.pangkat}, {item.golongan}
                                                    </Typography>
                                                </CardContent>
                                                <CardActions>
                                                    <Stack direction="row" spacing={1} justifyContent="center">
                                                        <Tooltip title="Hapus">
                                                            <IconButton aria-label="delete" color='error' onClick={() => onDelete(item)}>
                                                                <DeleteIcon />
                                                            </IconButton>
                                                        </Tooltip>
                                                        <Tooltip title="Edit">
                                                            <IconButton aria-label="edit" color="info" onClick={() => onEdit(item)}>
                                                                <EditIcon />
                                                            </IconButton>
                                                        </Tooltip>
                                                    </Stack>
                                                </CardActions>
                                            </Card>
                                        </Grid>
                                    )
                                })
                                :
                                "Tidak ada data"
                            }
                        </Grid>
                    </CardContent>
                </Card>
                :
                <Card variant='outlined'>
                    <CardHeader
                        title={
                            <Typography variant='h5'>Edit Bendahara</Typography>
                        }
                        avatar={
                            <Tooltip title="Kembali">
                                <IconButton variant="outlined" onClick={() => {
                                    setEdit(null)
                                }} color="error"><ArrowBackIcon /></IconButton>
                            </Tooltip>
                        }
                    />
                    <CardContent>
                        <Form id_pencairan={edit} setId={setEdit} />
                    </CardContent>
                </Card>
            }
        </>
    )
}

export default DataBud